import React from 'react';

/**
 * MilestonesCard — grid of earned/locked achievement badges.
 * Pure display; receives pre-computed milestones array from Dashboard.
 */
export function MilestonesCard({ milestones }) {
  return (
    <div className="card cp" style={{ marginBottom: 12 }}>
      <div className="st">🏅 Milestones</div>
      <div className="ms-grid">
        {milestones.map((m) => (
          <div key={m.id} className={'ms-badge' + (m.earned ? ' earned' : ' locked')}>
            <div className="ms-em">{m.earned ? m.em : '🔒'}</div>
            <div className="ms-name">{m.name}</div>
            <div className="ms-desc">{m.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
